import Link from 'next/link';
import React, { Component } from 'react';
import Layout from '../components/Layout';
import EventAPI from '../api/EventAPI';
import LocalAPI from '../api/LocalAPI';
import SectionAPI from '../api/SectionAPI';
import HighlightAPI from '../api/HighlightAPI';
import Button from 'react-bootstrap/Button';
import Router from 'next/router';
import { withRouter } from 'next/router';
import ConfirmationModal from '../components/ConfirmationModal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../components/Footer';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import SystemModal from '../components/SystemModal';
import ZoneAPI from '../api/ZoneAPI';
import moment from 'moment-timezone';
import Head from 'next/head';
import GenericHomeView from '../components/GenericHomeView';
import VideoPlayerModal from '../components/VideoPlayerModal';
import Search from './search';
import ReactGA from 'react-ga';
import { consoleLog } from '../managers/Logger';
import ReactPixel from 'react-facebook-pixel';
import CuratorAPI from '../api/CuratorAPI';
import UserCellView from '../components/UserCellView';
import GameplanCard from '../components/GameplanCard';
import Constants from '../components/Constants';
import { getImage } from '../managers/ImageHelper';
import TicketingPlug from '../components/TicketingPlug';
import DownloadPlug from '../components/DownloadPlug';
import { setZone } from '../store';

const divStyle = {
  backgroundImage: `url('/static/background3.jpg')`,
  height: 500 /* You must set a specified height */,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  boxShadow: `inset 0 0 0 2000px rgba(0,0,0,0.3)`,
  marginBottom: 20,
};

const CurationHome = class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: null,
      topEvent: null,
      zone: props.zone,
      sections: null,
      allZones: null,
      showConfirmation: false,
      coordinates: null,
      showStory: false,
      videoUrl: null,
      selectedEventId: null,
      loading: false,
      order: null,
      featured: [
        '/static/background3.jpg',
        '/static/background.jpg',
        '/static/background2.jpg',
      ],
      upcomingFeatured: [],
      cityCurators: [],
      carouselInterval: 4000,
    };
    this.myInput = React.createRef();
    this.zoneApi = new ZoneAPI(props.auth);
    this.eventApi = new EventAPI(props.auth);
    this.sectionsApi = new SectionAPI(props.auth);
  }

  static async getInitialProps(context) {
    var { id, domain } = context.query;
    const confirmationId = context.query.confirmation_id;

    consoleLog(`domain is ${domain}`);
    const highlightApi = new HighlightAPI();
    var zone = null;

    var shouldUseCoordinates = false;
    if (!domain || domain === 'localhost' || domain === 'www') {
      shouldUseCoordinates = true;
      domain = 'default';
    }

    if (!shouldUseCoordinates) {
      const zoneApi = new ZoneAPI(context.auth);
      const zoneResp = await zoneApi.getZone(domain);
      if (zoneResp && zoneResp.code !== -1) {
        zone = zoneResp;
        context.store.dispatch(setZone(zone));
      }
    }

    const highlight = await highlightApi.getActiveHighlight(domain);
    const startProps = {
      domain: domain,
      confirmationId: confirmationId,
      highlight: highlight,
      shouldUseCoordinates: shouldUseCoordinates,
      zone: zone,
    };

    return startProps;
  }

  async componentDidMount() {
    // TODO: Needed with new app domain?
    var sessionStorage = window.sessionStorage;
    sessionStorage.setItem('context', 'curation');

    ReactGA.initialize('UA-139931598-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.event({
      category: 'Homepage',
      action: 'view',
      label: this.props.domain,
    });
    ReactPixel.init('1603426606357869');
    ReactPixel.pageView();
    window.scrollTo(0, 0);
    consoleLog(`Events are ${this.props.events}`);
    const eventApi = new EventAPI();
    eventApi.setAuth(this.props.auth);
    if (
      this.props.confirmationId != null &&
      this.props.confirmationId !== undefined
    ) {
      const order = await eventApi.getOrder(this.props.confirmationId);
      consoleLog(order);
      if (order == null || order == undefined || order.code == -1) {
        return;
      }
      this.setState({
        showConfirmation: true,
        order: order,
        carouselInterval: 100000,
      });

      ReactGA.event({
        category: 'Booking',
        action: 'confirmed',
        label: 'redirect',
      });
    }

    // First get the zone. If the domain is default, fetch by coordinates.
    var zone = this.state.zone;
    if (this.props.domain === 'default' && this.props.shouldUseCoordinates) {
      const coordinates = await this.zoneApi.getCoordinates();
      consoleLog(coordinates);
      if (coordinates) {
        const zoneResult = await this.zoneApi.getZoneWithCoordinates(
          coordinates.lat,
          coordinates.lon,
        );
        if (
          zoneResult !== null &&
          zoneResult.code !== -1 &&
          zoneResult.length > 0
        ) {
          consoleLog('Zone from coordinates =');
          consoleLog(zoneResult);
          zone = zoneResult[0];
        } else {
          zone = await this.getAndSetZone('default');
        }
      }
    } else {
      if (!this.state.zone) {
        zone = await this.getAndSetZone(this.props.domain);
      }
    }

    this.getHighestRankedEvent(zone?.slug);

    this.props.dispatch(setZone(zone));
    const eventResult = await this.eventApi.getUpcomingEvents(zone?.slug);
    consoleLog('Zone events are');
    consoleLog(eventResult);
    if (eventResult && eventResult.code !== -1 && eventResult.length > 0) {
      this.setState({ events: eventResult });
    }

    this.setState({ zone: zone });

    const allZonesResult = await this.zoneApi.getAllZones();
    if (allZonesResult && allZonesResult.code !== -1) {
      this.setState({ allZones: allZonesResult });
    }

    const sectionResult = await this.sectionsApi.getSections(
      zone?.slug,
      'v1',
      'manual',
    );
    if (sectionResult && sectionResult.code !== -1) {
      this.setState({ sections: sectionResult });
    }

    const curatorApi = new CuratorAPI();
    const cityCurators = await curatorApi.getCurators(zone?.slug);

    if (cityCurators && cityCurators.code !== -1) {
      this.setState({ cityCurators: cityCurators });
    }
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  async getAndSetZone(domain) {
    const specificZoneResult = await this.zoneApi.getZone(domain);
    if (specificZoneResult && specificZoneResult.code !== -1) {
      this.setState({ zone: specificZoneResult });
      return specificZoneResult;
    } else {
      return null;
    }
  }

  getDivStyle(imageUrl) {
    const divStyle = {
      backgroundImage: `url('${imageUrl}')`,
      height: 550 /* You must set a specified height */,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      boxShadow: `inset 0 0 0 2000px rgba(0,0,0,0.3)`,
      marginBottom: 20,
    };
    return divStyle;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  getCarouselSubHeading(featured) {
    if (featured.type == 'event') {
      const event = this.props.events.find(function (newEvent) {
        return newEvent.id === featured.id;
      });
      const subheading = moment(event.start_date).format('ddd MMM Do, h:mm a');
      return subheading + ' at ' + event.place;
    } else {
      return featured.subheading;
    }
  }

  handleScroll() {
    if (window.scrollY > 500) {
      this.setState({ carouselInterval: 100000 });
    } else {
      this.setState({ carouselInterval: 4000 });
    }
  }

  async getHighestRankedEvent(zoneSlug) {
    const eventResp = await this.eventApi.getUpcomingEvents(zoneSlug, {
      limit: 1,
      min_rank: 1,
      orderBy: 'rank',
    });

    if (eventResp && eventResp.code !== -1 && eventResp.length > 0) {
      this.setState({ topEvent: eventResp[0] });
    }
  }

  static getCategoryMap(events) {
    const map = {};

    for (var event of events) {
      if (map[event.kind] === undefined) {
        map[event.kind] = [event];
      } else {
        map[event.kind].push(event);
      }
    }

    return map;
  }

  getPlayerModal() {
    return (
      <VideoPlayerModal
        showStory={this.state.showStory}
        url={this.state.videoUrl}
        handleHide={() => this.setState({ showStory: false })}
      />
    );
  }

  handleGoToArticle(articleId) {
    ReactGA.event({
      category: 'Story',
      action: 'click',
      label: 'Homepage',
      value: articleId,
    });
    this.setState({ loading: true });
    Router.push('/story/' + articleId);
  }

  onCarouselClicked(item, index) {
    ReactGA.event({
      category: 'Featured',
      action: 'click',
      label: 'Homepage',
      value: item.url,
    });
    if (index == 0) {
      return;
    }
    Router.push(item.url);
  }

  handleVideoClicked(videoUrl, eventId) {
    ReactGA.event({
      category: 'Video',
      action: 'view',
      label: 'Homepage',
      value: eventId,
    });
    this.setState({
      showStory: true,
      videoUrl: videoUrl,
      selectedEventId: eventId,
    });
  }

  getHeadImage() {
    if (this.props.featured.length > 1) {
      const val = this.props.featured[1].image;
      return val.toString();
    } else {
      const val = this.props.featured[0].image;
      return val.toString();
    }
  }

  getImageHeader() {
    const image = this.getHeadImage();
    return image;
  }

  handleCuratorNameClick(name) {
    const user = this.state.cityCurators.find(function (obj) {
      return obj.username == name;
    });
    if (user === undefined) {
      return;
    }

    window.location.href = user.curator.instagram;
  }

  getCuratorsView() {
    if (this.state.cityCurators.length == 0) {
      return null;
    }
    return (
      <div
        style={{
          ...Constants.centeredDiv,
          ...{ marginTop: 20, marginBottom: 20 },
        }}
      >
        <div style={{ ...{ minWidth: '50%' }, ...Constants.centeredDiv }}>
          <div>
            <div style={{ marginBottom: 20, textAlign: 'center' }}>
              <h3>Meet your curators</h3>
              <p style={{ color: Constants.grayColor }}>
                Keeping you connected to amazing experiences for the culture
              </p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {this.state.cityCurators.map((item, index) => (
                <UserCellView
                  image_url={item.profile_image}
                  username={item.username}
                  handleNameClick={(name) => this.handleCuratorNameClick(name)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getHomeView() {
    const storyModal = this.getPlayerModal();
    return (
      <div>
        <GenericHomeView
          userAgent={this.props.userAgent}
          zone={this.state.zone}
          topEvent={this.state.topEvent}
          allZones={this.state.allZones}
          events={this.state.events}
          sections={this.state.sections}
          curators={this.state.cityCurators}
          handleCuratorNameClick={(name) => this.handleCuratorNameClick(name)}
        />
        {storyModal}
        <SystemModal show={this.state.loading} loading />
      </div>
    );
  }

  getMovementTags() {
    if (this.props.highlight !== null && this.props.highlight.code !== -1) {
      return (
        <React.Fragment>
          <title>{Constants.headerTitle}</title>
          <meta name="description" content={Constants.headerDesc} />
          <meta property="og:title" content={this.props.highlight.title} />
          <meta
            property="og:description"
            content={this.props.highlight.message}
          />
          <meta property="og:image" content={this.props.highlight.image} />
        </React.Fragment>
      );
    } else if (this.props.zone) {
      return (
        <React.Fragment>
          <title>
            {'ETA: Discover hip-hop, afrobeat and black experiences in ' +
              this.props.zone.name}
          </title>
          <meta
            name="description"
            content={Constants.headerDesc + ` in ${this.props.zone.name}`}
          />
          <meta
            property="og:title"
            content={`ETA: Discover hip-hop, afrobeat and black experiences in ${this.props.zone.name}`}
          />
          <meta property="og:image" content={this.props.zone.image} />
          <meta property="og:description" content={Constants.headerDesc} />
        </React.Fragment>
      );
    } else if (this.props.domain === null || this.props.domain === 'default') {
      return (
        <React.Fragment>
          <title>{Constants.headerTitle}</title>
          <meta name="description" content={Constants.headerDesc} />
          <meta property="og:title" content={Constants.headerTitle} />
          <meta property="og:description" content={Constants.headerDesc} />
          <meta property="og:image" content={Constants.etaLogoUrl} />
        </React.Fragment>
      );
    }
  }

  getOpenGraphTags() {
    return (
      <Head>
        {this.getMovementTags()}
        {/* <meta name="apple-itunes-app" content="app-id=1448003243, affiliate-data=banner_website" /> */}
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta name="twitter:card" content="summary" />
        <link
          rel="shortcut icon"
          type="image/x-icon"
          href={Constants.etaLogoUrl}
        />
      </Head>
    );
  }

  render() {
    return (
      <div>
        {this.getOpenGraphTags()}
        {this.getHomeView()}
        <Col>
          <div>
            <Container>
              {this.state.order !== null && (
                <ConfirmationModal
                  show={this.state.showConfirmation}
                  order={this.state.order}
                  handleClose={() => this.setState({ showConfirmation: false })}
                />
              )}
            </Container>
          </div>
        </Col>
      </div>
    );
  }
};

export default connect((state) => state)(withRouter(CurationHome));
